<template>
  <v-col cols="12" class="pt-0">
    <v-row class="mb-4" v-if="tipoEmpresa">
      <div class="d-flex align-center">
        <v-icon color="#10155D" left class="mr-2">ph ph-info</v-icon>
        <span style="color: rgba(0, 0, 0, 0.5); font-weight: 700">
          Documentos a serem importados: <span class="text--disabled">{{documentosObrigatorios}}</span>
        </span>
      </div>
    </v-row>
    <v-row class="mb-4" v-if="listaDocumentosObrigatorios.length > 1">
      <div class="d-flex align-center">
        <span style="color: rgba(0, 0, 0, 0.5); font-weight: 700">
          Cada documento deve ser enviado individualmente. Arquivos com múltiplos documentos não serão aceitos.
        </span>
      </div>
    </v-row>
    <v-row class="pa-0">
      <v-col cols="6" class="pa-0 pr-4">
        <input-multi-files
          name="Documentos de constituição"
          v-model="model"
          label="Documentos de constituição"
          placeholder="Clique para importar o arquivo"
          append-icon="ph-paperclip"
          color="#10155D"
          show-size
          required
          :accept="$api.Onboarding.AcceptedFiles"
          :max-size="$api.Onboarding.MaxFileSizeIB"
          :max-files="$api.Onboarding.MaxFiles"
          @input="inputArquivos"
        >
          <template #selection="{_, index}">
            <span class="text--disabled" v-if="!index">Clique para importar o arquivo</span>
          </template>
        </input-multi-files>
      </v-col>
      <v-col class="pa-0 pl-4">
        <v-card outlined class="rounded-xl document-input">
          <v-card-title class="pa-2 pl-4 subtitle-2 grey lighten-4">
            Documentos importados:
          </v-card-title>

          <v-list v-if="arquivosAdicionados.length > 0" dense>
            <v-list-item
              v-for="(document, index) in arquivosAdicionados"
              :key="index"
              class=""
            >
              <v-list-item-content>
                <v-list-item-title class="text-underline">{{ document }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action class="ma-0">
                <v-btn
                  icon
                  small
                  @click="removerArquivo(document)"
                  color="grey"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-row v-else justify="center" class="pa-2">
            <small>Nenhum documento importado</small>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    value: null,
    tipoEmpresa: {
      type: Number,
      default: 0
    },
    codigoParceiro: null,
    codigoOperador: null
  },
  data () {
    return {
      arquivosAdicionados: []
    };
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    documentosObrigatorios () {
      return this.$aux.CategoriaEmpresaOnboarding.find(tipo => tipo.value === this.tipoEmpresa)?.documentos || ''
    },
    listaDocumentosObrigatorios () {
      return this.documentosObrigatorios
        ? this.documentosObrigatorios.split(' e ')
        : []
    }
  },
  methods: {
    inputArquivos (files) {
      this.arquivosAdicionados = files.map(file => file.name)
    },
    async removerArquivo (fileName) {
      const th = this
      var fileIsExisted = th.model.find(file => file.name === fileName && !!file?.aws)
      if (fileIsExisted) {
        var deleteSuccess = await th.$api.Dbs.DeleteArquivo({
          FilePath: fileIsExisted.path,
          CodigoParceiro: th.codigoParceiro,
          CodigoOperador: th.codigoOperador,
          CodigoArquivo: fileIsExisted.codigo
        })
        if (!deleteSuccess?.success) {
          th.$api.UI.ShowError('Erro', 'Erro ao tentar apagar o arquivo');
          return
        }
      }
      th.model = th.model.filter(file => file.name !== fileName);
      th.arquivosAdicionados = th.arquivosAdicionados.filter(file => file !== fileName);
    },
  },
  created () {
    const th = this
    if (th.model?.length > 0) {
      th.arquivosAdicionados = th.model.map(file => file.name)
    }
  }
}
</script>
<style scoped>
.document-input .v-card__title {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}
</style>
